import React, {useState} from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import ErrorToast from "../views/common/ErrorToast";
import axios from "../utils/apiClient";

const StyledUpload = styled.div`

  .custom-file ::-webkit-file-upload-button {

    display: none;

  }

`;
const componentName = "Upload";
const Upload = ({ setFile, disabled, accept, multiple }) => {

  const [errors, setErrors] = useState(null);
  const [inputKey, setInputKey] = useState("inputKey");


  const handleFileChange = async (e) => {
    const selectedFiles = e.currentTarget.files;
    const files = Array.from(selectedFiles || []);
    const file = files.length > 1 ? selectedFiles : files[0];

    if (!files.length) {
      return;
    }

    const fileEntries = await Promise.all(
      files.map(async (selectedFile) => {
        const fileBuffer = await selectedFile.arrayBuffer();
        return {
          name: selectedFile.name,
          content: Array.from(new Uint8Array(fileBuffer)),
        };
      })
    );

    const filesObj = fileEntries.reduce((acc, fileEntry) => {
      acc[fileEntry.name] = fileEntry.content;
      return acc;
    }, {});

    validate(filesObj, file);
  };


  const validate = (filesObj, file) => {
    axios
      .post(
        `${process.env.REACT_APP_REST_API_BASE_URL}/v1/file-upload/fileUpload/validateOnly`,
        filesObj,
        {
          headers: {
            "Content-Type": "application/json"
          },
        }
      )
      .then((res) => {
        const error = res?.data?.error && res?.data?.errorMessage ? res?.data?.errorMessage : ''
        if (error) {
          setErrors(error);
          setInputKey(`inputKey-${Math.random()}`)
        }
        else {
          setFile(file)
        }
      })
      .catch(() => {});
  };

  return (
    <StyledUpload className="input-group">
      <div className="custom-file">
        <label id={`${componentName}-uploadButton`} className="btn btn-primary me-2" htmlFor={`${componentName}-uploadFile`}>
          <i className="fa fa-cloud-upload me-2"></i> Choose File
        </label>
        <input
          disabled={disabled}
          type="file"
          onChange={(e) => handleFileChange(e)}
          id={`${componentName}-uploadFile`}
          aria-describedby="inputGroupFileAddon01"
          data-test="uploadInput"
          multiple={multiple}
          accept={accept}
          key={inputKey}
        />
      </div>
      {errors?.length > 0 &&
        <ErrorToast
          errorParam={errors}
          closeToast={() => setErrors(null)}
        />
      }
    </StyledUpload>
  );
};

Upload.propTypes = {
  setFile: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  accept: PropTypes.string,
  multiple: PropTypes.bool,
};

Upload.defaultProps = {
  disabled: false,
  accept: undefined,
  multiple: false,
};

export default Upload;
